import { createLogic, createLogicMiddleware } from 'redux-logic'
import { setModifierKeyState, hardwareKeyUp, TriState, mouseUp, mouseWheel, uncheckActive } from '../actions/toolbar'
import { getModifiersWithState } from '../epics/keyboard'

export const keyModifierHandlingLogic = createLogic({
  type: [hardwareKeyUp, mouseUp, mouseWheel, uncheckActive],
  latest: true,

  processOptions: {
    dispatchReturn: true,
  },

  process ({ getState }, dispatch, done) {
    const modifiers = getState().toolbar.modifiers

    getModifiersWithState(modifiers, TriState.Active)
      .forEach((keyName) => dispatch(setModifierKeyState({ key: keyName, state: TriState.Inactive })))

    done()
  }
})

export const keyModifierHandlingLogicMiddleware = createLogicMiddleware([keyModifierHandlingLogic])
